document.addEventListener('DOMContentLoaded', () => {
  const initializeTextureImages = (root = document) => {
    root.querySelectorAll?.('[data-file-swatch-image]').forEach((image) => {
      if (image.dataset.textureReady) return;
      image.dataset.textureReady = 'true';
      const source = image.dataset.fileSwatchSrc;
      const revealTexture = () => { image.classList.add('is-loaded'); };
      const useSolidColor = () => {
        image.classList.remove('is-loaded');
        image.removeAttribute('src');
      };
      image.addEventListener('load', revealTexture);
      image.addEventListener('error', useSolidColor);
      if (source) image.src = source;
      else useSolidColor();
    });
  };
  initializeTextureImages();
  new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => initializeTextureImages(node))))
    .observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      const card = swatch.closest('[data-product-card]');
      const image = card?.querySelector('.ptc-product-card__image--primary');
      if (image && swatch.dataset.cardImage) {
        card.classList.add('has-active-swatch');
        image.removeAttribute('srcset');
        image.src = swatch.dataset.cardImage;
      }
      card?.querySelectorAll('[data-card-swatch]').forEach((item) => {
        const active = item === swatch;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      return;
    }

    const openButton = event.target.closest('[data-card-options-open]');
    if (openButton) {
      openButton.closest('[data-product-card]')?.querySelector('[data-card-options-dialog]')?.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-card-options-close]');
    if (closeButton) {
      closeButton.closest('[data-card-options-dialog]')?.close();
      return;
    }

    const dialog = event.target.closest('[data-card-options-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });
});
